export const mainMenu = [
  {
    name: 'option',
    href: '/option',
    id: 0,
    callback: (link) => console.log(link)
  },
  {
    name: 'option',
    href: '/option',
    id: 1,
    callback: (link) => console.log(link)
  },
  {
    name: 'option',
    href: '/option',
    id: 2,
    callback: (link) => console.log(link)
  }
];

export const smallMenu = [
  {
    name: 'option',
    href: '/option'
  },
  {
    name: 'option',
    href: '/option'
  },
  {
    name: 'option',
    href: '/option'
  }
];


// WEBPACK FOOTER //
// ./src/containers/components/Header/constants/links.js